export const FETCH_LEX_ENROLLED = 'FETCH_LEX_ENROLLED';
export const FETCHING_LEX_ENROLLED = 'FETCHING_LEX_ENROLLED';
export const LEX_ENROLLED_SUCCESS = 'LEX_ENROLLED_SUCCESS';
export const LEX_ENROLLED_ERROR = 'LEX_ENROLLED_ERROR';
